import { BaseFetch } from "../main-model";
export default class ExportPP3Model extends BaseFetch {
  getExportPP3By = (data) =>
    this.authFetch({
      url: "export-pp3/getExportPP3By",
      method: "POST",
      body: JSON.stringify(data),
    });
  updateExportPP3StudentStatusBy = (data) =>
    this.authFetch({
      url: "export-pp3/updateExportPP3StudentStatusBy",
      method: "POST",
      body: JSON.stringify(data),
    });
}
